import { render, staticRenderFns } from "./dataAppDetail.vue?vue&type=template&id=c28d4968&scoped=true"
import script from "./dataAppDetail.vue?vue&type=script&lang=js"
export * from "./dataAppDetail.vue?vue&type=script&lang=js"
import style0 from "./dataAppDetail.vue?vue&type=style&index=0&id=c28d4968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28d4968",
  null
  
)

export default component.exports